export const model = {
  id: null,
  nationality: '',
  created_at: '',
  updated_at: '',
};
